<div class="row">
  <div class="l-pt-7 l-pb-7">
    <span class="cds-h2-demibold">{{ 'ee.no-records-found' | lang }}</span>
  </div>
</div>
<div class="row">
  <div class="cds-h3-light">
    <cds-button (click)="toHome()">{{ 'common.backToHome' | lang }}</cds-button>
  </div>
</div>
